import { IManagementVehicle } from 'Model/IManagementVehicle';
import { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import RequisitionAction from 'Store/Component/Requisition/RequisitionAction';
import ManagementVehicle from './ManagementVehicle';
import ConfirmationBee from "../../../../../assets/images/ConfirmationBee.svg"
import { IRequest } from 'Model/IRequest';
import { IReason } from 'Model/IReason';
import { initializeReason } from 'client/utils/RequisitionUtil';
import PriceInfoDispatch from 'Store/AssetManagement/PriceInfo/PriceInfoDispatch';
import { AttributeName, CONSTANTS } from "client/utils/constants";
import { setPriceInfo } from 'Store/AssetManagement/PriceInfo/PriceInfoAction';
import { popupInitialData } from 'utils';
import { getRequistionDropDown, setRequistionDropDown } from 'Store/AssetManagement/RequisitionDropDown/RequisitionDropDownAction';

interface IProps {
  setItemDetailComponent?: any,
  mobile: any,
  uniqueRefreshUUid: any
}

const ManagmentVehicleContainer = (props: IProps) => {

  const dispatch = useDispatch();
  const dispatchPriceInfo = PriceInfoDispatch.dispatchGetPriceInfo(dispatch)

  const order: IManagementVehicle = {
    requestIndex: 0,
    requestType: '',
    requestId: 0,
    orderTypeId: '',
    orderSubTypeId: '',
    managementVehicleIndex: 0,
    driverTitleId: 0,
    driverTitle: '',
    quantity: 1,
    price: '',
    isExistInCart: false,
    vehicleDriverDetails: [],
    vehicleDriverDetailsError: '',
    driveTrain: '',
    vehicleType: '',
    fuelType: '',
    fuelTypeId: ''
  }

  const initializeManagementVehicleValidation = {
    driverTitleError: '',
    quantityError: '',
    vehicleError: '',
    driveTrainError: '',
    fuelTypeError: ''
  }

  const showInitialState = {
    showDriverTitle: true,
    showDriveTrain: false,
    showFuelType: false,
    showVehicle: false
  }
  
  const initialDropDownValue = {
    driverTitleDropDown:{},
    driveTrainDropDown: {},
    fuelTypeDropDown: {},
    vehicleDropDown:{}
  }

  ///selectors
  const { isAddItemclick, 
    selectedRequisitionType,
    requestList, 
    managementVehicleList, 
    reasonList,
    priceInfo, 
    editRequestDetails, 
    isEditRequestClick,
    requisitionDropDown
  }: any = useSelector((state?: any) => ({
    selectedRequisitionType: state.RequisitionReducer.selectedRequisitionType,
    requestList: state.RequisitionReducer.requestList,
    managementVehicleList: state.RequisitionReducer.managementVehicleList,
    reasonList: state.RequisitionReducer.reasonList,
    priceInfo: state.PriceInfoReducer.priceInfo,
    isAddItemclick: state.RequisitionReducer.isAddItemclick,
    editRequestDetails: state.RequisitionReducer.editRequestDetails,
    isEditRequestClick: state.RequisitionReducer.isEditRequestClick,
    requisitionDropDown: state.RequisitionDropDownReducer.requisitionDropDown
  }));
  const [priceTemp, setPriceTemp] = useState<any>();
  const [orderDetails, setOrderDetails] = useState<any>(order);
  const [managementVehicleValidation, setManagementVehicleValidation] = useState<any>(initializeManagementVehicleValidation);
  const [popupContent, setPopupContent] = useState<any>(popupInitialData);
  const managementRef = useRef<any>([]);
  const [showDropDown, setShowDropDown] = useState<any>(showInitialState);
  const [dropDownValues, setDropDownValues] = useState<any>(initialDropDownValue);
  const [showAddItem, setShowAddItem] = useState<any>(false);

  useEffect(() => {
    if (requisitionDropDown?.hasOwnProperty('response')) {
      let dropDownTemp = requisitionDropDown?.response?.map((item: any) =>
        ({ text: item.text, value: item.value, label: item.text, key: item?.price ? item.price : "", showVehicleCapacity: item.selected ?? false })
      );
      if(requisitionDropDown?.childAttributeName === AttributeName.DRIVE_TRAIN){
        setShowDropDown({
          ...showDropDown,
          showDriveTrain: true
        })
        setDropDownValues({
          ...dropDownValues,
          driveTrainDropDown: dropDownTemp
        })
        if(editRequestDetails?.requestType === CONSTANTS.MANAGEMENT_VEHICLE){
          dispatch(getRequistionDropDown({
            subTypeId: selectedRequisitionType.orderRequestSubTypeId,
            childAttributeName: AttributeName.FUEL_TYPE,
            driveTrain: editRequestDetails.driveTrainId,
            driverTitle: editRequestDetails?.driverTitleId,
            vehicle: editRequestDetails?.vehicleTypeId,
            isProductionVehicle : false,
            isVehicleCapacity : false
          }))
        }
      } else if(requisitionDropDown?.childAttributeName === AttributeName.FUEL_TYPE){
        dropDownTemp.unshift({
          value: null,
          label: 'Select Fuel Type',
        })
        setShowDropDown({
          ...showDropDown,
          showFuelType: true
        })
        setDropDownValues({
          ...dropDownValues,
          fuelTypeDropDown: dropDownTemp
        })
      } else if(requisitionDropDown?.childAttributeName === AttributeName.VEHICLE_TYPE){
        setShowDropDown({
          ...showDropDown,
          showVehicle: true
        })
        setDropDownValues({
          ...dropDownValues,
          vehicleDropDown: dropDownTemp
        })
        if(editRequestDetails?.requestType === CONSTANTS.MANAGEMENT_VEHICLE){
          dispatch(getRequistionDropDown({
            subTypeId: selectedRequisitionType.orderRequestSubTypeId,
            childAttributeName: AttributeName.DRIVE_TRAIN,
            driverTitle: editRequestDetails?.driverTitleId,
            vehicle: editRequestDetails?.vehicleTypeId,
            isProductionVehicle : false,
            isVehicleCapacity : editRequestDetails?.showVehicleCapacity
          }))
        }
      } else if(requisitionDropDown?.childAttributeName === AttributeName.DRIVER_TITLE){
        setShowDropDown({
          ...showDropDown,
          showDriverTitle: true
        })
        setDropDownValues({
          ...dropDownValues,
          driverTitleDropDown: dropDownTemp
        })
        if(editRequestDetails?.requestType === CONSTANTS.MANAGEMENT_VEHICLE){
          dispatch(getRequistionDropDown({
            subTypeId: selectedRequisitionType.orderRequestSubTypeId,
            childAttributeName: AttributeName.VEHICLE_TYPE,
            driverTitle: editRequestDetails?.driverTitleId,
            isProductionVehicle : true
          }))
        }
      }
      dispatch(setRequistionDropDown([]))
    }
  }, [requisitionDropDown])

  useEffect(() => {
    setPriceTemp(priceInfo)
    if(isAddItemclick){
      if (priceInfo === undefined || priceInfo === "" || priceInfo <= 0) {
        showPricePopup()
        dispatch(RequisitionAction.setIsAddItemclick(false))
        dispatch(setPriceInfo(""))
        return
      }
      dispatch(RequisitionAction.setIsChangesOccured(true))
      props.setItemDetailComponent(true)
      dispatch(RequisitionAction.setShowItemDetails(true))

      //copy the global value      
      const requestListTemp = Array.isArray(requestList) && requestList.length > 0 ? JSON.parse(JSON.stringify(requestList)) : [];
      const managementVehicleListTemp = Array.isArray(managementVehicleList) && managementVehicleList.length > 0 ? JSON.parse(JSON.stringify(managementVehicleList)) : [];
      const reasonListTemp = Array.isArray(reasonList) && reasonList.length > 0 ? JSON.parse(JSON.stringify(reasonList)) : [];

      //check duplicate
      const managementVehicle: IManagementVehicle = {
        requestIndex: 0,
        requestType: '',
        requestId: 0,
        orderTypeId: selectedRequisitionType.orderRequestTypeId,
        orderSubTypeId: selectedRequisitionType.orderRequestSubTypeId,
        managementVehicleIndex: 0,
        driverTitleId: parseInt(orderDetails.driverTitle.value),
        driverTitle: orderDetails.driverTitle.text,
        quantity: orderDetails.quantity,
        price: priceInfo,
        isExistInCart: false,
        vehicleDriverDetails: [],
        vehicleDriverDetailsError: 'Driver is required',
        driveTrain: orderDetails.driveTrain.text,
        driveTrainId: orderDetails.driveTrain.value,
        vehicleType: orderDetails.vehicleType.text,
        vehicleTypeId: orderDetails.vehicleType.value,
        fuelType: orderDetails.fuelType.text,
        fuelTypeId: orderDetails.fuelType.value,
      };

      let blnDuplicate = false;
      managementVehicleListTemp.forEach((item : any) => {
        if (item.driverTitle === managementVehicle.driverTitle && item.vehicleType === managementVehicle.vehicleType && item.driveTrain === managementVehicle.driveTrain && item?.fuelType === managementVehicle?.fuelType) {
          blnDuplicate = true;
        }
      });

      if (blnDuplicate) {
        let description = (
          <>
            <p>Item list Section already have this vehicle combination.</p>
            <p>
              Please try other.
            </p>
          </>
        )

        setPopupContent({
          ...popupContent,
          titleImg: ConfirmationBee,
          title: "ALREADY EXISTS",
          isDialogVisible: true,
          isTitleWarning: false,
          subtextcontent: description,
          primaryBtnText: "",
          outlineBtnText: "Ok",
          isSingleConfirmationBtn: true,
          popupOutlinebtnOnclick: hideDialog,
          popupPrimarybtnOnclick: hideDialog
        });
        dispatch(RequisitionAction.setIsAddItemclick(false))
      dispatch(setPriceInfo(""))
        return;
      }

      //Request
      let nextRequestIndex = 0;
      requestListTemp.forEach((item : any) => {
        if (item?.requestIndex > nextRequestIndex) {
          nextRequestIndex = item?.requestIndex;
        }
      });
      nextRequestIndex = nextRequestIndex + 1;

      const request: IRequest = {
        requestIndex: nextRequestIndex,
        requestType: selectedRequisitionType.orderRequestType,
        showQuotePrice: false
      };
      requestListTemp.push(request);

      //Management Vehicle
      let nextManagementVehicleIndex = 0;
      managementVehicleListTemp.forEach((item : any) => {
        if (item.managementVehicleIndex > nextManagementVehicleIndex) {
          nextManagementVehicleIndex = item.nonStandardEquipmentIndex;
        }
      });
      nextManagementVehicleIndex = nextManagementVehicleIndex + 1;

      //set the index
      managementVehicle.requestIndex = request?.requestIndex;
      managementVehicle.requestType = request?.requestType;
      managementVehicle.managementVehicleIndex = nextManagementVehicleIndex;

      managementVehicleListTemp.push(managementVehicle);

      //Reason
      let nextReasonIndex = 0;
      reasonListTemp.forEach((item : any) => {
        if (item?.reasonIndex > nextReasonIndex) {
          nextReasonIndex = item?.reasonIndex;
        }
      });

      for (let i = 1; i <= orderDetails.quantity; i++) {

        nextReasonIndex = nextReasonIndex + 1;

        const reason: IReason = initializeReason(request, nextReasonIndex);

        reasonListTemp.push(reason);
      }

      dispatch(RequisitionAction.setIRequest(requestListTemp))
      dispatch(RequisitionAction.setIManagementVehicle(managementVehicleListTemp))
      dispatch(RequisitionAction.setIReason(reasonListTemp))
      dispatch(RequisitionAction.setIsAddItemclick(false))
    dispatch(setPriceInfo(""))
    }
  }, [priceInfo]);

  useEffect(() => {
    if (managementRef.current.length) {
      fieldFocus()
    }
    dispatch(getRequistionDropDown({
      subTypeId: selectedRequisitionType.orderRequestSubTypeId,
      childAttributeName: AttributeName.DRIVER_TITLE,
      isProductionVehicle : false
    }))
    setShowAddItem(false)
    setShowDropDown(showInitialState)
    setDropDownValues(initialDropDownValue)
  
   if(editRequestDetails?.requestType !== CONSTANTS.MANAGEMENT_VEHICLE){
      if(props.uniqueRefreshUUid)
      {
      setOrderDetails({
        ...orderDetails,
        vehicleType:"",
        driverTitle:"",
        quantity: 1,
        driveTrain:"",
        fuelType: ''
      });
      }
   }
  }, [props.uniqueRefreshUUid])

  const onIncrementQuantity = () => {
    setOrderDetails({
      ...orderDetails,
      quantity: orderDetails.quantity + 1
    });
  }
  const onDecrementQuantity = () => {
    if (orderDetails.quantity !== 0) {
      setOrderDetails({
        ...orderDetails,
        quantity: orderDetails.quantity - 1
      });
    }
  }
  const onChangeQuantity = (item: any) => {
    if (Number(item.target.value) > 0) {
      const orderDetailsTemp = { ...orderDetails };
      orderDetailsTemp.quantity = Number(item.target.value);
        let error = { ...ValidateQuantity(orderDetailsTemp, { ...managementVehicleValidation }) };
      setManagementVehicleValidation(error);
      setOrderDetails(orderDetailsTemp);
    }
  }

  const onChangeDriverTitle = (item: any) => {
    const orderDetailsTemp = { ...orderDetails };
    orderDetailsTemp.driverTitle = item;
    orderDetailsTemp.price = item.price;
    orderDetailsTemp.quantity = 1;
    orderDetailsTemp.vehicleType = "";
    orderDetailsTemp.driveTrain = "";
    orderDetailsTemp.fuelType = "";

    dispatch(getRequistionDropDown({
      subTypeId: selectedRequisitionType.orderRequestSubTypeId,
      childAttributeName: AttributeName.VEHICLE_TYPE,
      driverTitle: item.value,
      isProductionVehicle : false
    }))
    setShowAddItem(false)
    setShowDropDown(showInitialState)

      let error = { ...ValidateQuantity(orderDetailsTemp, { ...managementVehicleValidation }) };
      error = { ...ValidateDriverTitle(orderDetailsTemp, { ...error }) };
    setManagementVehicleValidation(error);
    setOrderDetails(orderDetailsTemp);
  }

  const fuelTypeOnChange = (item: any) => {
    const orderDetailsTemp = { ...orderDetails };
    orderDetailsTemp.fuelType = item;
    setShowAddItem(true)
    setOrderDetails(orderDetailsTemp);
  }

  const hideDialog = () => setPopupContent({ ...popupContent, isDialogVisible: false });

  const ValidateDriverTitle = (orderDetails: any, error: any) => {
    if (orderDetails.driverTitle === undefined || orderDetails.driverTitle === '' || orderDetails.driverTitle === null) {
      error.driverTitleError = "Please select driver title";
    } else {
      error.driverTitleError = "";
    }
    return error;
  }

  const ValidateVehicleType = (orderDetails: any, error: any) => {
    if (orderDetails.vehicleType === undefined || orderDetails.vehicleType === '' || orderDetails.vehicleType === null || orderDetails.vehicleType.text === "Select Vehicle") {
      error.vehicleError = "Please select vehicle";
    } else {
      error.vehicleError = "";
    }
    return error;
  }

  const ValidateDriveTrain = (orderDetails: any, error: any) => {
    if (orderDetails.driveTrain === undefined || orderDetails.driveTrain === '' || orderDetails.driveTrain === null || orderDetails.driveTrain.text === "Select Drive Train") {
      error.driveTrainError = "Please select drive train";
    } else {
      error.driveTrainError = "";
    }
    return error;
  }


  const ValidateQuantity = (orderDetails: IManagementVehicle, error: any) => {
    if (orderDetails.quantity === undefined || orderDetails.quantity == 0 || orderDetails.quantity === null) {
      error.quantityError = "Please enter valid quantity";
    } else {
      error.quantityError = "";
    }
    return error;
  }

  const validation = (orderDetail: any) => {
    let error = { ...managementVehicleValidation };
    error = { ...ValidateDriverTitle(orderDetail, error) };
    error = { ...ValidateDriveTrain(orderDetail, error) };
    error = { ...ValidateVehicleType(orderDetail, error) };
    error = { ...ValidateQuantity(orderDetail, error) };
    setManagementVehicleValidation(error);
    return error;
  }

  

  const reset = () => {
    setOrderDetails(order);
    setShowDropDown(showInitialState)
    setDropDownValues({
      driveTrainDropDown: {},
      fuelTypeDropDown: {},
      vehicleDropDown:{}
    })
    setShowAddItem(false)
  }

  const showPricePopup = () => {
    dispatch(setPriceInfo(""))
    let description = (
      <>
        <p>Pricing not available for this selection.</p>
        <p>
          Please select Non-Standard Equipment to request this vehicle.
        </p>
      </>
    )

    setPopupContent({
      ...popupContent,
      titleImg: ConfirmationBee,
      title: "PRICE NOT AVAILABLE",
      isDialogVisible: true,
      isTitleWarning: false,
      subtextcontent: description,
      primaryBtnText: "",
      outlineBtnText: "Ok",
      isSingleConfirmationBtn: true,
      popupOutlinebtnOnclick: () => { 
        if(!isEditRequestClick){
          reset(); 
        }
        hideDialog(); },
    });

  }

  const addOnClick = () => {

    dispatch(RequisitionAction.setIsAddToCartClick(false));
    props.setItemDetailComponent(true)

    //check validation
    let managementVehicleValidationError = validation(orderDetails);
    let validToShowItemDetail = true;

    for (let key in managementVehicleValidationError) {
      if (managementVehicleValidationError[key]) {
        validToShowItemDetail = false;
        return validToShowItemDetail
      }
    }
    if (validToShowItemDetail) {
      dispatch(RequisitionAction.setIsAddItemclick(true))

      const requestObject = {
        subTypeId: selectedRequisitionType.orderRequestSubTypeId,
        vehicleType: orderDetails.vehicleType.text,
        driveTrain: orderDetails.driveTrain.text,
        driverTitle: orderDetails.driverTitle.text,
        vehicleCapacity: "",
        noOfDoors: "",
        upfitOption: "",
        fuelType: orderDetails.fuelType.text
      }
      dispatchPriceInfo(requestObject);
    }
    
  }

  const onChangesVehicle = (item: any) => {
    const orderDetailsTemp = { ...orderDetails };
    orderDetailsTemp.vehicleType = item;
    orderDetailsTemp.driveTrain = "";
    orderDetailsTemp.fuelType = "";

    dispatch(getRequistionDropDown({
      subTypeId: selectedRequisitionType.orderRequestSubTypeId,
      childAttributeName: AttributeName.DRIVE_TRAIN,
      driverTitle: orderDetailsTemp?.driverTitle?.value,
      vehicle: item?.value,
      isProductionVehicle : false
    }))
    setShowAddItem(false)
    setShowDropDown({...showDropDown, showFuelType: false, showDriveTrain: false})
      let error = { ...ValidateVehicleType(orderDetailsTemp, { ...managementVehicleValidation }) };
    setManagementVehicleValidation(error);
    setOrderDetails(orderDetailsTemp);
  }

  const onChangeDriveTrain = (item: any) => {
    const orderDetailsTemp = { ...orderDetails };
    orderDetailsTemp.driveTrain = item;
    orderDetailsTemp.fuelType = "";

    dispatch(getRequistionDropDown({
      subTypeId: selectedRequisitionType.orderRequestSubTypeId,
      childAttributeName: AttributeName.FUEL_TYPE,
      driverTitle: orderDetailsTemp?.driverTitle?.value,
      vehicle: orderDetailsTemp?.vehicleType?.value,
      driveTrain: item.value,
      isProductionVehicle : false
    }))
    setShowAddItem(true)
    setShowDropDown({...showDropDown, showFuelType: false})
      let error = { ...ValidateDriveTrain(orderDetailsTemp, { ...managementVehicleValidation }) };
    setManagementVehicleValidation(error);
    setOrderDetails(orderDetailsTemp);
  }

  const fieldFocus = () =>{
    managementRef.current[0]?.focus()
  }

  const [isUpdateClick, setIsUpdateClick] = useState<any>(false)

  useEffect(() => {
    if(isUpdateClick){
      if (priceTemp === undefined || priceTemp === "" || priceTemp <= 0) {
        showPricePopup()
        return
      }
      dispatch(RequisitionAction.setIsChangesOccured(true))
      props.setItemDetailComponent(true)
      dispatch(RequisitionAction.setShowItemDetails(true))

      const managementVehicleListTemp = managementVehicleList?.length > 0 ? JSON.parse(JSON.stringify(managementVehicleList)) : [];

      let blnDuplicate = false;
      managementVehicleListTemp.forEach((item : any) => {
        if ((item?.requestIndex !== editRequestDetails?.requestIndex) && (item.driverTitle === orderDetails.driverTitle.text && item.vehicleType === orderDetails.vehicleType.text && item.driveTrain === orderDetails.driveTrain.text && item?.fuelType === orderDetails?.fuelType?.text)) {
          blnDuplicate = true;
        }
      });

      if (blnDuplicate) {
        let description = (
          <>
            <p>Item list Section already have this vehicle combination.</p>
            <p>
              Please try other.
            </p>
          </>
        )

        setPopupContent({
          ...popupContent,
          titleImg: ConfirmationBee,
          title: "ALREADY EXISTS",
          isDialogVisible: true,
          isTitleWarning: false,
          subtextcontent: description,
          primaryBtnText: "",
          outlineBtnText: "Ok",
          isSingleConfirmationBtn: true,
          popupOutlinebtnOnclick: hideDialog,
          popupPrimarybtnOnclick: hideDialog
        });
        dispatch(setPriceInfo(""))
        return;
      }

      managementVehicleListTemp?.map((item : any) => {
        if(item?.requestIndex === editRequestDetails?.requestIndex){      
          item.driveTrain = orderDetails.driveTrain.text;
          item.driveTrainId = orderDetails.driveTrain.value;
          item.driverTitle = orderDetails.driverTitle.text;
          item.driverTitleId = orderDetails.driverTitle.value;
          item.vehicleType = orderDetails.vehicleType.text;
          item.vehicleTypeId = orderDetails.vehicleType.value;
          item.price = priceTemp;
          item.fuelType = orderDetails?.fuelType?.text;
          item.fuelTypeId = orderDetails?.fuelType?.value;
        }
      })
      dispatch(RequisitionAction.setIsUpdateSuccessAlert(true))
      dispatch(RequisitionAction.setIManagementVehicle(managementVehicleListTemp))
      dispatch(RequisitionAction.setIsEditRequestClick(false))
      dispatch(RequisitionAction.setEditRequestDetails({}))
      dispatch(setPriceInfo(""))
    }
    
  }, [priceInfo])
  
  const updateOnClick = () =>{
    setIsUpdateClick(true)
    dispatch(RequisitionAction.setIsAddToCartClick(false));
    props.setItemDetailComponent(true)

    //check validation
    let managementVehicleValidationError = validation(orderDetails);
    let validToShowItemDetail = true;

    for (let key in managementVehicleValidationError) {
      if (managementVehicleValidationError[key]) {
         validToShowItemDetail = false;
         return validToShowItemDetail
      }
    }

    if (validToShowItemDetail) {
      const requestObject = {
        subTypeId: selectedRequisitionType.orderRequestSubTypeId,
        vehicleType: orderDetails.vehicleType.text,
        driveTrain: orderDetails.driveTrain.text,
        driverTitle: orderDetails.driverTitle.text,
        vehicleCapacity: "",
        noOfDoors: "",
        upfitOption: "",
        fuelType: orderDetails.fuelType.text
      }
      dispatchPriceInfo(requestObject);
    }  
  }


  useEffect(() => {
    if(editRequestDetails?.requestType === CONSTANTS.MANAGEMENT_VEHICLE){
      fieldFocus()
      dispatch(RequisitionAction.setIsUpdateSuccessAlert(false))
      const managementVehicleListTemp = managementVehicleList?.length > 0 ? JSON.parse(JSON.stringify(managementVehicleList)) : [];
      setShowAddItem(true)
      setShowDropDown({
        showDriveTrain: true,
        showFuelType: true,
        showVehicle: true,
        showDriverTitle: true
      })
      managementVehicleListTemp?.map((item : any) => {
        if(item?.requestIndex === editRequestDetails?.requestIndex){ 
            const orderDetailsTemp = { ...orderDetails };

            orderDetailsTemp.driverTitle = {
              key : editRequestDetails?.driverTitleId,
              label : editRequestDetails?.driverTitle,
              text : editRequestDetails?.driverTitle,
              value : editRequestDetails?.driverTitleId,
            };
            
            orderDetailsTemp.vehicleType = {
              key : `${editRequestDetails?.vehicleTypeId}`,
                label : editRequestDetails?.vehicleType,
                text : editRequestDetails?.vehicleType,
                value : `${editRequestDetails?.vehicleTypeId}`,
              }

            orderDetailsTemp.driveTrain = {
              key : `${editRequestDetails.driveTrainId}`,
              label : editRequestDetails?.driveTrain,
              text : editRequestDetails?.driveTrain,
              value : `${editRequestDetails.driveTrainId}`,
            }

            orderDetailsTemp.fuelType = {
              key : `${editRequestDetails.fuelTypeId}`,
              label : editRequestDetails?.fuelType,
              text : editRequestDetails?.fuelType,
              value : `${editRequestDetails.fuelTypeId}`,
            }

            orderDetailsTemp.price = editRequestDetails.price;
            orderDetailsTemp.quantity = editRequestDetails.quantity;

            setOrderDetails(orderDetailsTemp)  
        }
      })
      
    }
  }, [editRequestDetails]);



  const cancelEditRequestType = () => {
    dispatch(RequisitionAction.setEditRequestDetails({}))
    dispatch(RequisitionAction.setIsEditRequestClick(false))
  }

  return <ManagementVehicle
    orderDetails={orderDetails}
    onIncrementQuantity={onIncrementQuantity}
    onDecrementQuantity={onDecrementQuantity}
    addOnClick={addOnClick}
    managementRef={managementRef}
    onChangeQuantity={onChangeQuantity}
    onChangeDriverTitle={onChangeDriverTitle}
    managementVehicleValidation={managementVehicleValidation}
    popupContent={popupContent}
    hideDialog={hideDialog}
    onChangesVehicle={onChangesVehicle}
    onChangeDriveTrain={onChangeDriveTrain}
    updateOnClick={updateOnClick}
    isEditRequestClick={isEditRequestClick}
    cancelEditRequestType={cancelEditRequestType}
    fuelTypeOnChange={fuelTypeOnChange}
    dropDownValues = {dropDownValues}
    showAddItem = {showAddItem}
    showDropDown = {showDropDown}
  />
}

export default ManagmentVehicleContainer;

